import { Component, OnInit, TemplateRef } from '@angular/core';

import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BsModalService, ModalOptions, BsModalRef } from 'ngx-bootstrap';
import { DialogService } from 'ng2-bootstrap-modal';
import { CommondialogComponent } from '../../Shared/commondialog/commondialog.component';
import { ProductGroup } from './productgroup';
import { ProductgroupService } from './productgroup.service';
import { LocalService } from '../../local.service';

@Component({
  selector: 'app-productgroup',
  templateUrl: './productgroup.component.html',
  styleUrls: ['./productgroup.component.css']
})
export class ProductgroupComponent implements OnInit {

  sendMenuId: 35;
  sendPageName: string = 'Product Group';
  //action rights
  _menuId: any;
  _actionRights: any;
  submitShow: boolean;
  readOnly: boolean; add: boolean; edit: boolean; delete: boolean;

  productGroupForm: FormGroup;
  productGroups: ProductGroup[] = [];
  productGroupsactive: ProductGroup[] = [];
  productGroup: ProductGroup;
  deleteResult: boolean
  postresult: boolean
  putDResult: boolean
 productGroupModalRef: BsModalRef;
  operation: string;
  userid: number;
  productgroupid: number;
  submitted = false;
  active: number;
  unamePattern: string;
  confmsg: string;
  p: number = 1; searchText: string;
  itemsPerPage: number = 10;
  config: ModalOptions = {
    backdrop: 'static',
    keyboard: false,
    animated: true,
    ignoreBackdropClick: true,
    class: 'modal-dialog-centered'

  }
  showall: boolean = true;
  showallstatus: boolean = false;
  constructor(
  
    private modalService: BsModalService,
    private formBuilder: FormBuilder,
    private router: Router,
    private toastr: ToastrService, private dialogService: DialogService, 
    private productgroupService: ProductgroupService, private localService: LocalService) {
    //code to get relavent menu id      
    if (this.router.getCurrentNavigation().extras.state != undefined) {
      localStorage.setItem('Branch_menuid', this.router.getCurrentNavigation().extras.state.menuid);
      localStorage.setItem('Branch_action', this.router.getCurrentNavigation().extras.state.action);
      this._menuId = this.router.getCurrentNavigation().extras.state.menuid;
      this.sendMenuId = this._menuId;
      this._actionRights = this.router.getCurrentNavigation().extras.state.action;
    }
    else {
      if (this._menuId == undefined)
        this._menuId = localStorage.getItem('Branch_menuid');
      this.sendMenuId = this._menuId;
      if (this._actionRights == undefined)
        this._actionRights = localStorage.getItem('Branch_action');
    }
  }

  ngOnInit() {
    this.checkIsMenuMapped();
    // console.log(this._menuId); console.log(this._actionRights);
    this.productGroupForm = this.formBuilder.group({
      productgroupid: [''],
      productgroup: ['', [Validators.required]],
      active: ['']
    });
    this.searchText = '';
    this.getAll();
    //for action rights
    this.readOnly = false;
    this.add = false;
    this.edit = false;
    this.delete = false;
    this.submitShow = false;
    this.getActionRightsList();
  }

  key: string = 'productgroup'; //set default
  reverse: boolean = false;
  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }

  checkIsMenuMapped()
  {
    const arrays = this.localService.getJsonValue("menulist");
    const notauthorized = this.localService.getJsonValue("notauthorizedproductgroup");
    let data = arrays.find(ob => ob['name'] === 'Product Group');
    if((data == undefined || data =='') && (notauthorized!=="true"))
    {
      this.localService.setJsonValue("notauthorizedproductgroup","true");
      this.toastr.error('You are not authorized to access this page.');
      this.router.navigate(["home"]);
    }
    if(notauthorized=="true"){
      this.localService.setJsonValue("notauthorizedproductgroup",null);
      this.router.navigate(["home"]);      
    }
  }

  //assigning value from menu rights button
  getActionRightsList() {
    var btnToEnable = JSON.parse(this._actionRights);
    if (btnToEnable.length > 0) {
      btnToEnable.forEach(d => {
        if (d != undefined) {
          if (d == 1)
            this.readOnly = true;
          else if (d == 2) {
            this.readOnly = true;
            this.add = true;
            this.submitShow = true;
          }
          else if (d == 3) {
            this.readOnly = true;
            this.edit = true;
            // this.submitShow = true;
          }
          else if (d == 4) {
            this.readOnly = true;
            this.delete = true;
          }
        }
      });
    }
  }

  clearForm() {
    //for action rights
    if (this.add == true)
      this.submitShow = true;
    else
      this.submitShow = false;
    this.productGroupModalRef.hide();
  }

  getAll() {
    this.productGroups = [];
    this.productGroupsactive = [];
    this.productgroupService.Get().subscribe((res:any) => {
      this.productGroups = res;
      if (this.showallstatus == true) {
        this.productGroups.forEach(data => {
          if (data.active == 1) {
            this.productGroupsactive.push(data);
          }
        });
        this.productGroups = [];
        this.productGroups = this.productGroupsactive;
      }
    }, error => { this.toastr.error('Error while getting data'); });

  }

  getactiveinactive(showallp) {
    this.productGroupsactive = [];
    this.showall = showallp;
    this.showallstatus = showallp;
    if (this.showall == true) {
      this.showall = false;
      this.productGroups.forEach(data => {
        if (data.active == 1) {
          this.productGroupsactive.push(data);
        }
      });
      this.productGroups = [];
      this.productGroups = this.productGroupsactive;
    }
    else {
      this.showall = true;
      this.productGroups = [];
      this.getAll();
    }
  }

  get g() { return this.productGroupForm.controls; }

  Post(productgroup: ProductGroup) {

    this.submitted = true;
    // stop here if form is invalid
    //if (this.productGroupForm.invalid) {
    //  console.log(this.g);
    //  console.log(this.productGroupForm.errors);
    //}

    if ((productgroup.productgroup.trim() == undefined) || (productgroup.productgroup.trim() == '')) {
      this.toastr.error('Branch should not be empty');
      return;
    }

    var msg = null;

    //this.userid = +localStorage.getItem("userid");
    this.userid = +this.localService.getJsonValue("userid");
    productgroup.productgroup = productgroup.productgroup.trim();
    if (this.operation == 'add') {

      productgroup.createdby = this.userid;
      msg = "Record Added Successfully";
      this.productgroupService.Post(productgroup).subscribe(res => {
        if (res.status == 200) {
          if (res != undefined) {
            if (res.body != 0) {
              this.productGroupModalRef.hide();
              this.getAll();
              this.toastr.success('Data added successfully');
            }
            else { this.toastr.warning('Record already exists.'); }
          }
        };
      },
        error => {
          this.toastr.error("Error while doing the operation");
          this.postresult = false
        })
    }
    else if (this.operation = 'update') {
      this.submitShow = true;
      productgroup.modifiedby = this.userid;
      msg = "Record updated successfully";
      this.productgroupService.Put(productgroup).subscribe(res => {
        if (res.status == 200) {
          if (res != undefined) {
            ;
            if (res.body != 0) {
              this.productGroupModalRef.hide();
              this.getAll();
              this.toastr.success('Data updated successfully');
            }
            else { this.toastr.warning('Record already exists.'); }
          }
        };
      },
        error => {
          this.toastr.error("Error while doing the operation");
          this.postresult = false
        })
    }

    //console.log(this.productGroupForm.value);


  }

  ChangeActive(e) {
    if (e.currentTarget.checked) {
      this.productGroupForm.value.active = 1;
    } else {
      this.productGroupForm.value.active = 0
    }
  }

  OpenConfirmTemplate(productgroup, template: TemplateRef<any>) {
    if (productgroup.active == 0) {
      this.confmsg = "activate";
    }
    else
      this.confmsg = "deactivate";
    let showpopup = this.dialogService.addDialog(CommondialogComponent,
      {
        title: 'Please Confirm',
        message: 'Are you sure you want to ' + this.confmsg + ' this record ?',
        hclass: 'modelsuccess',
        oktext: 'Yes',
        canceltext: 'No',
        okshow: true,
        cancelshow: true
      }).subscribe((isConfirmed) => {
        if (isConfirmed) {
          this.productGroup = productgroup;

          this.Delete();

        }

      });

  }


  Delete() {

    var msg;
    if (this.productGroup.active == 0) {
      this.productGroup.active = 1
      msg = "Record activated successfully"
    }
    else {
      this.productGroup.active = 0;
      msg = "Record deactivated successfully"
    }
    //this.userid = +localStorage.getItem("userid");
    this.userid = +this.localService.getJsonValue("userid");
    this.productGroup.modifiedby = this.userid;

    this.productgroupService.Delete(this.productGroup).subscribe(res => {
      this.toastr.success(msg);
      this.getAll();
    },
      error => { this.deleteResult = false })

  }



  hidePopup() {
    this.productGroupModalRef.hide();
  }
  openProductGroupModal(template: TemplateRef<any>, type, prdctgrp?: ProductGroup) {


    this.operation = type
    if (type == 'update') {
      this.productGroupForm.controls['productgroupid'].setValue(prdctgrp.productgroupid);
      this.productGroupForm.controls['productgroup'].setValue(prdctgrp.productgroup);
      this.productGroupForm.controls['active'].setValue(prdctgrp.active);
      this.productGroup = prdctgrp;
    }
    if (type == 'add') {
      this.productGroupForm.controls['productgroupid'].setValue(0);
      this.productGroupForm.controls['productgroup'].setValue('');
      this.productGroupForm.controls['active'].setValue(1);
    }
    this.productGroupModalRef = this.modalService.show(template, this.config);
    const aa = document.getElementsByClassName('modal-content');
    aa[0].classList.remove("modal-content");
  }


}
